import React from 'react';
import DashboardTitle from "../../layout/DashboardTitle";
import { Flex } from 'antd';
import SettingsSidebar from './SettingsSidebar';
import CustomTitle from '../../components/CustomTitle';

function Settings({ isUpdateForm = false, backUrl, children }) {
  return (
    <>
      {
        isUpdateForm ? null : <DashboardTitle title="Settings" />
      }

      <Flex className='settings-mobile-menu' gap={36}>
        <SettingsSidebar isUpdateForm={isUpdateForm} backUrl={backUrl} />
        <Flex vertical={true} gap={32} style={{ width: "100%" }} className='settings-right-content'>
          {children}
        </Flex>
      </Flex>
    </>
  );
}

export default Settings;
